// extracted by mini-css-extract-plugin
export default {"content":"SeriesStats_content__zNgV3","divider":"SeriesStats_divider__Xos1F","lamportsAndLabel":"SeriesStats_lamportsAndLabel__aewUW"};